<template>
    <!-- История событий -->
    <div class="scrollable-table-container">
        <!-- События должны выводиться отсортированные по дате возникновения от ранних к поздним -->
        <table class="notification-table">
            <tr class="row-title"><th v-for="header in headers" :key="header">
                {{ header }}
            </th>
            </tr>
            <tr v-for="event in data" :key="event">
                <td v-for="(header, index) in headers" :key="header">
                    <span v-if="index == 'num'" class="numLink NHNumOrder" @click="openOrder(event[index])" title="Перейти к заказу">{{ event[index] }}</span>
                    <span v-else>{{ event[index] }}</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: 'NotificationsComponent',
    data() {
        return {
            headers: {
                date: "Дата", 
                type: "Тип события",
                description: "Описание",
                author: "Автор",
                num: "Заказ"
            },
            data: [],
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        // Инициализация
        init() {
            this.data = [
                {
                    date: "14.11.2023 9:30", // Дата и время создания уведомления 
                    type: "Статус изменен", // Информация по изменению
                    description: "Обработка - отгружен", // Дополнительная Информация по изменению
                    author: "Служба КС Umatex", // Автор изменения (Значения: «Клиент» или «Служба КС»)
                    num: "1251521621152" // Номер заказа. При клике должна открываться страница просмотра заказа
                },
                { 
                    date: "12.11.2023 9:30", 
                    type: "Статус изменен",
                    description: "Обработка - отгружен",
                    author: "Служба КС Umatex",
                    num: "1251521621152"
                },
                { 
                    date: "13.11.2023 9:30", 
                    type: "Статус изменен",
                    description: "Обработка - отгружен",
                    author: "Служба КС Umatex",
                    num: "1251521621152"
                },
            ],
            // Сортировка по убыванию
            this.data.sort((a, b) => b.date - a.date);
        },

        // Открыть заказ в новой вкладке
        openOrder(order) {
            console.log(order)
            this.$router.push({
                path: '/order/detail',
                params: { id: 55 },
                meta: { title: 'Заказ № 6' }
            });
        }
    }
}
</script>